import React from 'react';
import { urlApi } from '../Constants/Global';

import SectionHeader from '../Components/SectionHeader';
import Bg from '../Medias/Photos/photo-bg7.jpg';
import { Col, Container, Row } from 'react-bootstrap';
import logo from '../Medias/Logos/logo.png';

const LegalNotice = ({ contents }) => {
  console.log(contents)

  return (
    <>
      <SectionHeader topic='Legal Notice' detail={<span style={{ fontSize: '18px' }}></span>} bg={Bg} textSize={10} />
      <section className='pt-5 pb-5'>
        <Container className='pt-5 pb-5'>
          <Row className='mb-5'>
            <Col xs={{ span: 4, offset: 4 }} md={{ span: 2, offset: 5 }}>
              <img src={logo} className='w-100' />
            </Col>
          </Row>
          <Row>
            <Col xs={{ span: 12, offset: 0 }} md={{ span: 8, offset: 2 }}>
              <p>“PT & Associates” which is abbreviated as “PTA” refers to the law firm founded by Dr. Piti Eiamchamroonlarp and Dr. Tanatthep Tianprasit, who are attorneys at law admitted to the Lawyers Council of Thailand, and hold distinguished academic posts in top universities and institutions of Thailand. PTA works or collaborates with attorneys at law admitted to the Lawyers Council of Thailand, as well as professionals and consultants, in accordance with applicable professional rules and codes. PTA as a law firm empowers its legal professionals with well-designed and curated in-house and external training and actual legal practice opportunities that strengthen the entire legal profession. </p>
              <p>PTA with the financial support of corporate social responsibility (CSR) donors maintains the non-for-profit “PTA Energy Law Center” abbreviated as “PTA ELC”” to create an open and neutral platform for energy law scholarship and discussions primarily through the four modes of (i) news and events, (ii) regulatory updates, (iii) energy education and trends, and (iv) publications. PTA ELC collaborates with energy law researchers from various backgrounds including academicians, industry practitioners and government representatives to test and refine their ideas. As an independent and impartial research institution, the PTA ELC adheres to academic and content neutrality while remaining relevant to genuine interests and concerns of various stakeholders along the energy supply chain.</p>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default LegalNotice